import React, { Component } from "react";
import Props from "./Props";

class AlignContent extends Component {
  state = {
    property: "align-content",
    definition:
      "The align-content property specifies how flex lines are distributed along the cross axis in a flexbox container. In flexbox layout, the main axis is in the flex-direction (default is 'row', horizontal), and the cross axis is perpendicular to the main axis (default is 'column', vertical).",
    defaultOption: "flex-start",
    dependencyClass: "wrap-item",
    options: [
      "flex-start",
      "flex-end",
      "center",
      "stretch",
      "space-between",
      "space-around",
    ],
    flexContainer: { fcHeight: "400px", fcWidth: "600px" },
    flexItems: [
      { label: 1, itemWidth: "200px" },
      { label: 2, itemWidth: "120px" },
      { label: 3, itemWidth: "100px" },
      { label: 4, itemWidth: "140px" },
      { label: 5, itemWidth: "160px" },
      { label: 6, itemWidth: "180px" },
    ],
  };

  render() {
    const { state } = this;

    return <Props {...state} />;
  }
}

export default AlignContent;
